export default __webpack_public_path__ + "static/media/need-help-mobile.db5d5c5d.svg";